import { addDoc, collection, deleteDoc, doc, getDocs, orderBy, query, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "./firebase";

const COLLECTION_NAME = "wodBenchmarkLibrary";

const cleanMovement = (movement = {}) => ({
    type: movement.type || "wod_movement",
    movement: movement.movement || "",
    movementId: movement.movementId || "",
    category: movement.category || "",
    reps: movement.reps || "",
    load: movement.load || "",
    distance: movement.distance || "",
    calories: movement.calories || "",
    time: movement.time || "",
    height: movement.height || "",
    unit: movement.unit || "reps",
    notes: movement.notes || "",
    scaling: {
        rx: movement.scaling?.rx || "",
        intermediate: movement.scaling?.intermediate || "",
        beginner: movement.scaling?.beginner || "",
    },
});

const cleanBlock = (block = {}) => ({
    name: block.name || "WOD",
    workoutType: "wod",
    componentType: block.componentType || "metcon",
    format: block.format || "amrap",
    scoreType: block.scoreType || "rounds_reps",
    timeCap: block.timeCap || "",
    rounds: block.rounds || "",
    stimulus: block.stimulus || "",
    scalingNotes: block.scalingNotes || "",
    sets: (block.sets || []).map(cleanMovement),
});

const cleanBenchmark = (benchmark = {}) => ({
    name: benchmark.name || "",
    group: benchmark.group || "box",
    track: benchmark.track || "crossfit",
    format: benchmark.format || "amrap",
    scoreType: benchmark.scoreType || "rounds_reps",
    timeCap: benchmark.timeCap || "",
    rounds: benchmark.rounds || "",
    stimulus: benchmark.stimulus || "",
    equipment: benchmark.equipment || [],
    tags: benchmark.tags || [],
    blocks: (benchmark.blocks || []).map(cleanBlock),
});

const WodBenchmarkLibraryService = {
    getAll: async (idTenant) => {
        if (!idTenant) return [];

        const q = query(
            collection(db, "tenants", idTenant, COLLECTION_NAME),
            orderBy("createdAt", "desc")
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, source: "tenant", ...doc.data() }));
    },

    save: async ({ idTenant, authUser, benchmark }) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");
        if (!benchmark?.name?.trim()) throw new Error("Nome do WOD é obrigatório.");

        const payload = {
            benchmark: cleanBenchmark(benchmark),
            name: benchmark.name.trim(),
            group: benchmark.group || "box",
            createdAt: serverTimestamp(),
            createdBy: {
                uid: authUser?.uid || "system",
                name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema",
            },
        };

        const docRef = await addDoc(collection(db, "tenants", idTenant, COLLECTION_NAME), payload);
        return { id: docRef.id, source: "tenant", ...payload };
    },

    update: async ({ idTenant, benchmarkId, benchmark }) => {
        if (!idTenant || !benchmarkId) throw new Error("Tenant e WOD IDs são obrigatórios.");
        if (!benchmark?.name?.trim()) throw new Error("Nome do WOD é obrigatório.");

        const payload = {
            benchmark: cleanBenchmark(benchmark),
            name: benchmark.name.trim(),
            group: benchmark.group || "box",
            updatedAt: serverTimestamp(),
        };

        await updateDoc(doc(db, "tenants", idTenant, COLLECTION_NAME, benchmarkId), payload);
        return { id: benchmarkId, source: "tenant", ...payload };
    },

    delete: async ({ idTenant, benchmarkId }) => {
        if (!idTenant || !benchmarkId) throw new Error("Tenant e WOD IDs são obrigatórios.");
        await deleteDoc(doc(db, "tenants", idTenant, COLLECTION_NAME, benchmarkId));
        return true;
    },
};

export default WodBenchmarkLibraryService;
